export default "__VITE_ASSET__e6807f52__"